export default __webpack_public_path__ + "static/media/ic_gender.bee6b37d.svg";